import { useCallback } from 'react';

import { Theme } from 'src/apollo/sites';

import { useOptionalRestaurant, useRestaurant } from 'shared/components/common/restaurant_context/RestaurantContext';

type ThemeConsumerType<T, > = (theme: Theme) => T

const getThemeColorScheme = <T, >(theme: Theme, themeConsumer: ThemeConsumerType<T>, defaultColor: T) => {
  try {
    if(theme?.enabled && theme?.colorScheme) {
      return themeConsumer(theme);
    } else {
      return defaultColor;
    }
  } catch(_) {
    return defaultColor;
  }
};

export const useThemeColorScheme = () => {
  const { restaurant: { theme } } = useRestaurant();

  return useCallback(<T, >(themeConsumer: ThemeConsumerType<T>, defaultColor: T) => {
    return getThemeColorScheme(theme as Theme, themeConsumer, defaultColor);
  }, [theme]);
};

export const useOptionalThemeColorScheme = () => {
  const theme = useOptionalRestaurant()?.restaurant?.theme;

  return useCallback(<T, >(themeConsumer: ThemeConsumerType<T>, defaultColor: T) => {
    return getThemeColorScheme(theme as Theme, themeConsumer, defaultColor);
  }, [theme]);
};


